<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="devId"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="机构" v-model="institution"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="型号" v-model="termVersion"></el-input>
      </el-col>
      <el-col :span="6">
        <el-select v-model="devType" placeholder="类型">
          <el-option value="all" label="全部"></el-option>
          <el-option value="1" label="节点"></el-option>
          <el-option value="2" label="网关"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <router-link to="/equipment/gateway/equi/add">
          <el-button type="success">新增</el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-button type="primary">批量关联设备</el-button>
      </el-col>
      <el-col :span="6">
        <el-button type="text" @click="downloadTemplate">下载模板</el-button>
      </el-col>
    </el-row>

    <el-table
      :data="data"
      border
      stripe
      style="width: 100%"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="id" label="设备编号" width="160">
      </el-table-column>
      <el-table-column prop="termName" label="设备类型">
      </el-table-column>
      <!-- <el-table-column prop="gatewayId" label="关联网关编号"> </el-table-column> -->
      <el-table-column prop="devAlias" label="设备名称"> </el-table-column>
      <el-table-column prop="machineName" label="整机名称"> </el-table-column>
      <el-table-column prop="termVersion" label="整机型号"> </el-table-column>
      <el-table-column prop="version" label="设备版本"> </el-table-column>
      <el-table-column prop="romModel" label="固件型号"> </el-table-column>
      <el-table-column prop="firmVersion" label="固件版本"> </el-table-column>
      <el-table-column prop="hardwareModel" label="硬件型号"> </el-table-column>
      <el-table-column prop="institution" label="机构/个人"> </el-table-column>
      <el-table-column prop="stockStatus" label="库存状态">
        <template slot-scope="scope">
          {{ scope.row.stockStatus | kucun }}
        </template>
      </el-table-column>
      <el-table-column prop="useStatus" label="使用状态"> </el-table-column>
      <el-table-column prop="poweronTime" label="开机时间">
      </el-table-column>
      <el-table-column prop="frequency" label="LORA频率"> </el-table-column>
      <!-- <el-table-column prop="lastReportTime" label="最近上报数据时间">
      </el-table-column> -->
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <router-link :to="'/equipment/gateway/equi/lishi/' + scope.row.id">
            <el-button type="text" size="small">历史数据</el-button>
          </router-link>
          <template v-if="scope.row.hasAssociated">
            <el-popconfirm title="要解除设备吗？" @confirm="delDev(scope.row)">
              <el-button
                type="text"
                style="color: red"
                size="small"
                slot="reference"
                >解除设备
              </el-button>
            </el-popconfirm>
          </template>
          <template v-else>
            <el-button type="text" size="small" @click="openDev(scope.row)"
              >关联设备</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>

    <el-dialog title="关联设备" :visible.sync="open" @close="closeDailog">
      <el-row class="search-add" :gutter="10">
        <el-col :span="8">
          <el-input placeholder="设备编号" v-model="MdevId"></el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="Msearch">搜索</el-button>
        </el-col>
      </el-row>
      <el-table
        :data="relevanceData"
        border
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <template v-if="this.rowData.devType === '2'">
          <el-table-column type="selection" width="55"> </el-table-column>
        </template>
        <template v-else>
          <el-table-column align="center" width="55" label="">
            <template slot-scope="scope">
              <el-radio
                v-model="templateSelection"
                :label="scope.row.id + ''"
                @change="handleRadioChange(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
        </template>

        <el-table-column prop="id" label="设备编号" width="160">
        </el-table-column>
        <el-table-column prop="devType" label="设备类型">
          <template slot-scope="scope">
            {{ scope.row.devType === "1" ? "节点" : "网关" }}
          </template>
        </el-table-column>
        <el-table-column prop="devAlias" label="设备名称"> </el-table-column>
      </el-table>
      <div class="tableDel-Page">
        <el-pagination
          :current-page="relevancePagin.pageNum"
          :page-size="relevancePagin.pageSize"
          layout="prev, pager, next"
          :total="relevancePagin.total"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDailog">取 消</el-button>
        <el-button type="primary" @click="handleRelevance">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      devId: "",
      MdevId: "",
      institution: "",
      termVersion: "",
      devType: "all",
      open: false,
      data: [],
      rowData: {},
      relevanceData: [],
      env: this.getEnv(),
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      relevancePagin: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      multipleSelection: [],
      templateSelection: "",
    };
  },
  filters: {
    kucun(value) {
      switch (value) {
        case "0":
          return "待入库";
          break;
        case "1":
          return "入库";
          break;
        case "2":
          return "出库";
          break;
      }
    },
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    Msearch() {
      this.relevancePagin.pageNum = 1;
      this.getRelevanceList(this.rowData.devType);
    },
    handleCurrentChange(val) {
      this.relevancePagin.pageNum = val;
      this.getRelevanceList(this.rowData.devType);
    },
    handleRadioChange(row) {
      console.log(row.id);
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
        termType: +this.devType === 1 ? 'node_terminal' : +this.devType === 2 ? 'gateway' : 'all'
      };
      if (this.devId.trim() != "") {
        params.devId = this.devId;
      }
      if (this.institution.trim() != "") {
        params.institution = this.institution;
      }
      if (this.termVersion.trim() != "") {
        params.termVersion = this.termVersion;
      }
      this.$http
        .post(`/manage/dev/list`, params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getRelevanceList(devType) {
      let params = {
        pageNum: this.relevancePagin.pageNum,
        pageSize: this.relevancePagin.pageSize,
        devType,
      };
      if (this.MdevId.trim() != "" && devType === "1") {
        params.devId1 = this.MdevId;
      }
      if (this.MdevId.trim() != "" && devType === "2") {
        params.devId2 = this.MdevId;
      }
      this.$http
        .post(`${this.env}/gatewaymanage/gwdev/associa/list`, params)
        .then((results) => {
          this.relevanceData = results["data"]["data"]["records"];
          this.relevancePagin.total = results["data"]["data"]["total"];
        });
    },
    downloadTemplate() {
      this.$http
        .get(`${this.env}/gatewaymanage/gwdev/download/template`)
        .then((results) => {
          console.log(results);
        });
    },
    handleRelevance() {
      let params;
      if (this.rowData.devType === "2") {
        params = {
          gwId: this.rowData.id,
          devIds: this.multipleSelection.map((i) => i.id) || [
            this.templateSelection,
          ],
        };
      }
      if (this.rowData.devType === "1") {
        params = {
          gwId: this.templateSelection,
          devIds: [this.rowData.id],
        };
      }
      this.$http
        .post(`${this.env}/gatewaymanage/gwdev/associa`, params)
        .then((results) => {
          if (results["data"]["code"] === 0) {
            this.open = false;
            this.getList();
          }
        });
    },
    openDev(row) {
      this.open = true;
      this.getRelevanceList(row.devType);
      this.rowData = row;
    },
    delDev(row) {
      let params = {
        gwId: row.gwId,
        devIds: [row.id],
      };
      this.$http
        .post(`${this.env}/gatewaymanage/gwdev/disassocia`, params)
        .then((results) => {
          if (results["data"]["code"] === 0) {
            this.getList();
          }
        });
    },
    closeDailog() {
      this.open = false;
      this.MdevId = "";
      this.relevancePagin.pageNum = 1;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.network.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.network.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.network.baitengfa.com";
      }
    },
  },
  components: { Pagination },
};
</script>

<style scoped>
.tab {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}
</style>